import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M20 12H10m10 5h-4m4-10H4" }));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
